import { ABSTRACT_ACTION_TYPES } from '../consts/abstractActionTypes'
import { ARG_TYPES } from '../consts/argTypes'

/*
Abstract action should be automatically converted to concreteActions
*/

export function FixtureDigitalWrite() {
  return {
    type: ABSTRACT_ACTION_TYPES.FIXTURE_DIGITAL_WRITE,
    name:'Set Output',
    description:'Set {arg0:Fixture} to {arg1:Value}', 
    argTypes:[ARG_TYPES.FIXTURE_OUTPUT, ARG_TYPES.ARG_0_TYPE],
    returnType:ARG_TYPES.ACTION,
    // defaultArgs:[
    //   {mode:'PREDEF', value:'PREDEF_FIRST'},
    //   {mode:'PREDEF', value:'BOOLEAN_TRUE'},
    //   ],
  }
}

export function FixtureTurnTo() {
  return {
    type: ABSTRACT_ACTION_TYPES.FIXTURE_TURN_TO,
    name:'Turn Servo To',
    description:'Set {arg0:Fixture} to {arg1:Value} in {arg2:Duration} ms', 
    argTypes:[ARG_TYPES.FIXTURE_SERVO, ARG_TYPES.INTEGER, ARG_TYPES.INTEGER],
    returnType:ARG_TYPES.ACTION,
    // defaultArgs:[
    //   {mode:'PREDEF', value:'PREDEF_FIRST'},
    //   {mode:'PREDEF', value:'BOOLEAN_TRUE'},
    //   ],
  }
}

export function playSfx(sfxId, targetSpeaker, volume) {
  return {
    type: ABSTRACT_ACTION_TYPES.PLAY_SFX,
    name:'Play a Sound',
    description:'Play the sound {arg0:sound} {arg1:mode}, volume {arg2:volume}/100',
    argTypes:[ARG_TYPES.SFX, ARG_TYPES.PERIODIC, ARG_TYPES.INTEGER],
    returnType:ARG_TYPES.ACTION,
    sfxId,
    targetSpeaker,
    // defaultArgs:[
    //   {mode:'VALUE', value:'UNDEFINED'},
    //   {mode:'PREDEF', value:'PERIODIC_ONCE'},
    //   {mode:'VALUE', value:"100"},
    //   ],
  }
}

export function stopSfx(sfxId, targetSpeaker) {
  return {
    type: ABSTRACT_ACTION_TYPES.STOP_SFX,
    name:'Stop a Sound',
    description:'Stop the sound {arg0:sound}',
    argTypes:[ARG_TYPES.SFX],
    returnType:ARG_TYPES.ACTION,
    sfxId,
    targetSpeaker,
  }
}

export function setVolumeSfx() {
  return {
    type: ABSTRACT_ACTION_TYPES.SET_VOLUME_SFX,
    name:'Set a Sound Volume',
    description:'Set the sound {arg0:sound} to volume {arg1:int}',
    argTypes:[ARG_TYPES.SFX, ARG_TYPES.INTEGER],
    returnType:ARG_TYPES.ACTION,
  }
}

export function setPanSfx() {
  return {
    type: ABSTRACT_ACTION_TYPES.SET_PAN_SFX,
    name:'Set a Sound Pan (Does not work)',
    description:'Set the pan {arg0:sound} to pan {arg1:int}',
    argTypes:[ARG_TYPES.SFX, ARG_TYPES.INTEGER],
    returnType:ARG_TYPES.ACTION,
  }
}

export function setVariable() {
  return {
    type: ABSTRACT_ACTION_TYPES.SET_VARIABLE,
    name:'Set Variable',
    description:'Set {arg0:Variable} equals to: {arg1:Value}',
    argTypes:[ARG_TYPES.VARIABLE, ARG_TYPES.ARG_0_TYPE],
    returnType:'ACTION',
  }
}

export function playVideo(mediaId, targetPod = 0, targetScreen = 0) {
  return {
    type: ABSTRACT_ACTION_TYPES.PLAY_VIDEO,
    name:'Play a Video',
    description:'Play the video {arg0:video}',
    argTypes:[ARG_TYPES.VIDEO],
    returnType:ARG_TYPES.ACTION,
    mediaId,
    targetPod,
    targetScreen,
  }
}

export function stopVideo(mediaId, targetPod = 0, targetScreen = 0) {
  return {
    type: ABSTRACT_ACTION_TYPES.STOP_VIDEO,
    name:'Stop a Video',
    description:'Stop the video {arg0:video}',
    argTypes:[ARG_TYPES.VIDEO],
    returnType:ARG_TYPES.ACTION,
    mediaId,
    targetPod,
    targetScreen,
  }
}

export function startPlaylist(playlistId, targetSpeaker) {
  return {
    type: ABSTRACT_ACTION_TYPES.START_PLAYLIST,
    name:'Start a Playlist',
    description:'Start the playlist {arg0:playlist}',
    argTypes:[ARG_TYPES.PLAYLIST],
    returnType:ARG_TYPES.ACTION,
    playlistId,
    targetSpeaker,
  }
}

export function stopPlaylist(playlistId, targetSpeaker) {
  return {
    type: ABSTRACT_ACTION_TYPES.STOP_PLAYLIST,
    name:'Stop a Playlist',
    description:'Stop the playlist {arg0:playlist}',
    argTypes:[ARG_TYPES.PLAYLIST],
    returnType:ARG_TYPES.ACTION,
    playlistId,
    targetSpeaker,
  }
}

export function startBundle() {
  return {
    type: ABSTRACT_ACTION_TYPES.START_BUNDLE,
    name:'Start a Bundle',
    description:'Starts the bundle {arg0:bundle} on screen {arg1:1}. (1 or 2)',
    argTypes:[ARG_TYPES.BUNDLE, ARG_TYPES.INTEGER],
    returnType:ARG_TYPES.ACTION,
  }
}

export function stopBundle() {
  return {
    type: ABSTRACT_ACTION_TYPES.STOP_BUNDLE,
    name:'Stop a Bundle',
    description:'Stops the bundle {arg0:bundle} on screen {arg1:1}. (1 or 2)',
    argTypes:[ARG_TYPES.BUNDLE, ARG_TYPES.INTEGER],
    returnType:ARG_TYPES.ACTION,
  }
}

export function displayText(text) {
  return {
    type: ABSTRACT_ACTION_TYPES.DISPLAY_TEXT,
    name:'Display Text',
    description:'Display the text: {arg0:text}',
    argTypes:[ARG_TYPES.STRING],
    returnType:ARG_TYPES.ACTION,
    text,
  }
}

export function setStatus() {
  return {
    type: ABSTRACT_ACTION_TYPES.SET_STATUS,
    name:'Set Status',
    description:'Set the status of the game to {arg0:status}',
    argTypes:[ARG_TYPES.STATUS],
    returnType:ARG_TYPES.ACTION,
    /*defaultArgs:[
      {mode:'VALUE', value:'0'},
      {mode:'VALUE', value:'0'},
      {mode:'PREDEF', value:'BOOLEAN_TRUE'},
      ],*/
  }
}

export function setLanguage() {
  return {
    type: ABSTRACT_ACTION_TYPES.SET_LANGUAGE,
    name:'Set Language',
    description:'Set the language to {arg0:language}',
    argTypes:[ARG_TYPES.LANGUAGE],
    returnType:ARG_TYPES.ACTION,
    /*defaultArgs:[
      {mode:'VALUE', value:'0'},
      {mode:'VALUE', value:'0'},
      {mode:'PREDEF', value:'BOOLEAN_TRUE'},
      ],*/
  }
}


export function sendPodNetwordString() {
  return {
    type: ABSTRACT_ACTION_TYPES.SEND_POD_NETWORK_STRING,
    name: 'Send network string',
    description: 'Send {arg0:value} to another pod',
    argTypes:[ARG_TYPES.STRING],
    returnType:ARG_TYPES.ACTION,
  }
}

export function sendPodNetwordKV() {
  return {
    type: ABSTRACT_ACTION_TYPES.SEND_POD_NETWORK_KV,
    name: 'Send network key - value',
    description: 'Send Key:{arg0:key} Value:{arg1:value} to another pod',
    argTypes:[ARG_TYPES.STRING, ARG_TYPES.INTEGER],
    returnType:ARG_TYPES.ACTION,
  }
}

export function sendBundle() {
  return {
    type: ABSTRACT_ACTION_TYPES.SEND_BUNDLE,
    name: 'Send to the bundles',
    description: 'Send {arg0:keyword} to the bundles',
    argTypes:[ARG_TYPES.BI_KEY],
    returnType:ARG_TYPES.ACTION,
  }
}

export function sendBundleKV() {
  return {
    type: ABSTRACT_ACTION_TYPES.SEND_BUNDLE_KEY_VALUE,
    name: 'Send key-value to the bundles',
    description: 'Send {arg0:keyword} with value {arg1:value} to the bundles',
    argTypes:[ARG_TYPES.BIKV_KEY, ARG_TYPES.STRING],
    returnType:ARG_TYPES.ACTION,
  }
}

export function gpioFunctionBlink() {
  return {
    type: ABSTRACT_ACTION_TYPES.GPIO_FUNCTION_BLINK,
    returnType:ARG_TYPES.ACTION,
    name:'GPIO Blink',
    description: 'Blink {arg0:pin} every {arg1:integer} ms',
    argTypes:[ARG_TYPES.FIXTURE_OUTPUT, ARG_TYPES.INTEGER],
  }
}

export function gpioFunctionTurnTo() {
  return {
    type: ABSTRACT_ACTION_TYPES.GPIO_FUNCTION_TURN_TO,
    returnType:ARG_TYPES.ACTION,
    name:'GPIO Turn To',
    description: 'Turn the servo {arg0:pin} to {arg1:integer} degree in {arg2:integer} ms',
    argTypes:[ARG_TYPES.PIN_OUTPUT, ARG_TYPES.INTEGER, ARG_TYPES.INTEGER],
  }
}

export function startTimer() {
  return {
    type: ABSTRACT_ACTION_TYPES.TIMER_START,
    returnType:ARG_TYPES.ACTION,
    name:'Time - Set Timer',
    description: 'Start {arg0:timer} as a {arg1:periodic} that will expire {arg2:integer} ms',
    argTypes:[ARG_TYPES.TIMER, ARG_TYPES.PERIODIC, ARG_TYPES.INTEGER],
  }
}

export function operateTimer() {
  return {
    type: ABSTRACT_ACTION_TYPES.TIMER_OPERATION,
    returnType:ARG_TYPES.ACTION,
    name:'Time - Control a Timer',
    description: '{arg0:operation} {arg1:timer}',
    argTypes:[ARG_TYPES.PLAY_OPERATION, ARG_TYPES.TIMER],
  }
} 

export function sequenceStart() {
  return {
    type: ABSTRACT_ACTION_TYPES.SEQUENCE_START,
    returnType:ARG_TYPES.ACTION,
    name:'Sequence - Start a sequence',
    description: 'Set {arg0:ouput} to alternate 1 and 0 according to those timings (ms) 1:{arg1:time} 0:{arg2:time} 1:{arg3:time} 0:{arg4:time} 1:{arg5:time} 0:{arg6:time} 1:{arg7:time} 0:{arg8:time} 1:{arg9:time} 0:{arg10:time}',
    argTypes:[ARG_TYPES.FIXTURE_OUTPUT, ARG_TYPES.INTEGER, ARG_TYPES.INTEGER, ARG_TYPES.INTEGER,
     ARG_TYPES.INTEGER, ARG_TYPES.INTEGER, ARG_TYPES.INTEGER, ARG_TYPES.INTEGER, ARG_TYPES.INTEGER, 
     ARG_TYPES.INTEGER, ARG_TYPES.INTEGER],
  }
} 

export function blinkXTimes() {
  return {
    type: ABSTRACT_ACTION_TYPES.BLINK_X_TIMES,
    returnType:ARG_TYPES.ACTION,
    name:'Sequence - Blink x times',
    description: 'Set {arg0:ouput} to alternate 1 and 0 for {arg1:time} times. Duration 1 (ms):{arg2:time}, Duration 0:{arg3:time}, end value: {arg4:endValue} (1 or 0)',
    argTypes:[ARG_TYPES.FIXTURE_OUTPUT, ARG_TYPES.INTEGER, ARG_TYPES.INTEGER, 
      ARG_TYPES.INTEGER, ARG_TYPES.INTEGER],
  }
} 

export function wait() {
  return {
    type: ABSTRACT_ACTION_TYPES.WAIT,
    returnType:ARG_TYPES.ACTION,
    name:'Wait x milliseconds',
    description: 'Wait {arg0:x} milliseconds',
    argTypes:[ARG_TYPES.INTEGER],
  }
} 

export function ifAction() {
  return {
    type: ABSTRACT_ACTION_TYPES.IF_ACTION,
    returnType:ARG_TYPES.ACTION,
    name:'If then',
    description: 'If {arg0:x} then {arg1:action}',
    argTypes:[ARG_TYPES.CONDITION, ARG_TYPES.ACTION],
  }
} 

export function multipleAction() {
  return {
    type: ABSTRACT_ACTION_TYPES.MULTIPLE_ACTION,
    returnType:ARG_TYPES.ACTION,
    name:'Multiple Actions',
    description: '{arg0:action0}, {arg1:action1}, {arg2:action2}, {arg3:action3}',
    argTypes:[ARG_TYPES.ACTION, ARG_TYPES.ACTION, ARG_TYPES.ACTION, ARG_TYPES.ACTION],
  }
} 

export function padInputCheckboxAssign() {
  return {
    type: ABSTRACT_ACTION_TYPES.PAD_INPUT_CHECKBOX_ASSIGN_ACTION,
    returnType:ARG_TYPES.ACTION,
    name:'Check the checkbox',
    description: 'Switch the pad checkbox {arg0:checkbox} to {arg1:integer}',
    argTypes:[ARG_TYPES.PAD_INPUT_CHECKBOX, ARG_TYPES.INTEGER]
  }
}